import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TickComponent } from './tick/tick.component';
import { MenuComponent } from './menu/menu.component';
import { InfoMobileComponent } from './info-mobile/info-mobile.component';
import { InfoComponent } from './info/info.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { CloseMobileComponent } from './close-mobile/close-mobile.component';
import { CloseComponent } from './close/close.component';
import { CheckComponent } from './check/check.component';
import { CheckTickComponent } from './check-tick/check-tick.component';
import { EditComponent } from './edit/edit.component';



@NgModule({
  declarations: [TickComponent, MenuComponent, InfoMobileComponent, InfoComponent, DropDownComponent, CloseMobileComponent, CloseComponent, CheckComponent, CheckTickComponent, EditComponent],
  imports: [
    CommonModule
  ],
  exports: [TickComponent, MenuComponent, InfoMobileComponent, InfoComponent, DropDownComponent, CloseMobileComponent, CloseComponent, CheckComponent, CheckTickComponent, EditComponent]
})
export class IconModule { }
